import type { IconProps } from '../../types'

const EmojiIcon = ({ size = 20, color, ...restProps }: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 34.25 34.25' {...restProps}>
    <path
      fill={color}
      d='M17.125 0C7.668 0 0 7.667 0 17.125S7.668 34.25 17.125 34.25c9.459 0 17.125-7.667 17.125-17.125S26.584 0 17.125 0zm6.32 11.422a2.454 2.454 0 0 1 0 4.906 2.454 2.454 0 0 1 0-4.906zm-12.641 0a2.453 2.453 0 1 1 0 4.907 2.453 2.453 0 0 1 0-4.907zm15.561 11.657a11.223 11.223 0 0 1-9.24 4.864 11.215 11.215 0 0 1-9.24-4.865 1.5 1.5 0 1 1 2.472-1.7c1.536 2.233 4.067 3.565 6.769 3.565s5.231-1.332 6.771-3.565a1.502 1.502 0 0 1 2.086-.385c.679.47.851 1.403.382 2.086z'
    />
  </svg>
)

export default EmojiIcon
